import { render } from "./ReviewSetting.vue?vue&type=template&id=3ad7face&scoped=true"
import script from "./ReviewSetting.vue?vue&type=script&lang=js"
export * from "./ReviewSetting.vue?vue&type=script&lang=js"

import "./ReviewSetting.vue?vue&type=style&index=0&id=3ad7face&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad7face"]])

export default __exports__